// ============= Imports =============
import {
  FetchDataProps,
  ApiResponse,
  GraphApiResponse,
} from '../components/container/forms/types';
import { tokenManager } from '../utils/tokenManager';

// ============= Constants =============
const BASE_URL = 'https://graph.microsoft.com/v1.0/users';
const HEADERS = {
  ConsistencyLevel: 'eventual', // Required for $search
};

// ============= Types =============
interface GraphHeaders extends Record<string, string> {
  Authorization: string;
  ConsistencyLevel: string;
}

// ============= Utility Functions =============
/**
 * Constructs filter parameters for Graph API query
 * @param searchValue Search term to filter users
 * @returns Formatted filter string
 */
// const constructFilterParams = (searchValue: string): string => {
//   return [
//     `startswith(givenName,'${searchValue}')`,
//     `startswith(surname,'${searchValue}')`,
//     `startswith(userPrincipalName,'${searchValue}')`,
//   ].join(' or ');
// };

/**
 * Creates headers for Graph API request
 * @param token Authentication token
 * @returns Headers object
 */
const createHeaders = (token: string): GraphHeaders => ({
  Authorization: `Bearer ${token}`,
  ...HEADERS,
});

// ============= Main Function =============
/**
 * Fetches users from Microsoft Graph API based on search criteria
 * @param getAccessToken Function to acquire access token
 * @param searchValue Search string to filter users
 * @returns Promise with API response containing user data or error
 */
export const fetchGraphUsers = async ({
  getAccessToken,
  searchValue,
}: FetchDataProps): Promise<ApiResponse<GraphApiResponse>> => {
  try {
    console.log('🔄 Fetching Graph API data...');

    // Token acquisition with required scopes

    const token = await getAccessToken();
    if (!token) {
      throw new Error('Failed to acquire Graph API token');
    }
    tokenManager.logTokenInfo(token, 'Graph API');

    // URL construction
    // const filterParams = constructFilterParams(searchValue);

    const url = `${BASE_URL}?$search="displayName:${searchValue}" OR "userPrincipalName:${searchValue}"&$orderby=displayName&$count=true`;
    console.log('🌐 Making request to:', url);

    // API request
    const response = await fetch(url, {
      method: 'GET',
      headers: createHeaders(token),
    });

    // Response handling
    if (!response.ok) {
      console.log(`HTTP error! status: ${response.status}`);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = (await response.json()) as GraphApiResponse;
    console.log('✅ Graph API data fetched successfully');

    return {
      success: true,
      data,
    };
  } catch (error) {
    console.error('🔴 Error fetching Graph API data:', error);
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unknown error occurred',
    };
  }
};

/* Alternative search implementation (commented out for reference)
const url = `${BASE_URL}?$search="displayName:${searchValue}"&$orderby=displayName&$count=true`;
*/
